/**
 * Stories Archive — Filter, Search & Pagination
 */

import { initArchiveFilter } from './archive-filter.js';
import { revealStagger, motionTokens } from './motion-primitives.js';

document.addEventListener('DOMContentLoaded', () => {
	initArchiveFilter({
		archiveSelector: '.rmh-stories-archive',
		gridSelector: '[data-stories-grid]',
		countSelector: '[data-stories-count]',
		tabSelector: '.rmh-stories-tab',
		paginationButtonSelector: '.rmh-stories-page-btn',
		scrollTargetSelector: '.rmh-stories-tab',
		searchParam: 'story_search',
		errorContext: 'Stories filter error',
		gridWrapperClass: 'grid grid-cols-1 gap-x-8 gap-y-6 md:grid-cols-2 md:gap-y-[72px] lg:grid-cols-3',
		paginationContainerAttr: 'data-stories-pagination',
		defaultStrings: {
			noResults: 'No stories found.',
			error: 'Something went wrong. Please try again.',
		},
	});

	// Initial-paint stagger for the first row of story cards. AJAX-replaced
	// grids (filter / search) don't re-fire — that's intentional, scrolling
	// the page rapidly through filter changes shouldn't feel choreographed.
	const grid = document.querySelector('.rmh-stories-archive [data-stories-grid] > div');
	if (grid) {
		revealStagger(grid, {
			childSelector: ':scope > article',
			stagger: motionTokens.stagger,
			duration: motionTokens.durMd,
			maxAnimated: 6,
		});
	}
});
